var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('TheOrganizationAddSpace',{attrs:{"newSpaceType":_vm.spaceTypes.EDUCATION_SPACE,"spaceTypeIcon":"school"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }